function createEmptyNode(el, overIframeZIndex) {
  const containerWidth = el.parentNode.clientWidth
  const containerHeight = el.parentNode.clientHeight
  const overIframeDiv = document.createElement('div')
  overIframeDiv.style.position = 'absolute'
  overIframeDiv.style.width = containerWidth + 'px'
  overIframeDiv.style.height = containerHeight + 'px'
  overIframeDiv.style.top = '0'
  overIframeDiv.style.left = '0'
  overIframeDiv.style.background = 'transparent'
  overIframeDiv.style.zIndex = overIframeZIndex || 10
  el.parentNode.insertBefore(overIframeDiv, el)
  return overIframeDiv
}

/**
 * 自定义拖拽指令，使用该指令时，该元素的postion须为absolute, 它的父元素的postion须为relative。
 * 如果isOverIframe 设置为 true， 则需要设置overIframeZIndex低于 挂载节点的层级
 */
export default {
  inserted(el, binding) {
    /**
     * origin: 相对于哪个方向放置，取值：top-left(默认) || top-right || bottom-left || bottom-right
     * isOverIframe: 被拖动的元素是否在iframe上面
     * handle：鼠标在指定元素上才允许拖动
     */
    const { origin, isOverIframe, handle, overIframeZIndex } = binding.value || {}

    const hanleElm = handle ? el.querySelector(handle) : el

    if (!hanleElm) return
    el.handleMousedown = (e) => {
      /** 如果被拖动的元素在iframe元素上面，快速拖动时该元素会可能导致它和鼠标脱离。
       * 因为此时鼠标已经作用在iframe上面，导致document.addEventListener('mousemove'）等事件失效了
       * 此时可以创建一个透明的元素盖在iframe上面，停止拖动时再移除
       * */
      let overIframeDiv = isOverIframe ? createEmptyNode(el, overIframeZIndex) : null

      const startClientX = e.clientX
      const startClientY = e.clientY
      const disX = startClientX - el.offsetLeft
      const disY = startClientY - el.offsetTop

      function handleMouseMove(e) {
        let left = e.clientX - disX
        let top = e.clientY - disY

        // 移动范围不能超过父元素
        const containerWidth = el.parentNode.clientWidth
        const containerHeight = el.parentNode.clientHeight
        const elmWidth = el.clientWidth
        const elmHeight = el.clientHeight

        /** 左边距最大值 */
        let maxLeft = containerWidth - elmWidth
        /** 上边距最大值 */
        let maxTop = containerHeight - elmHeight

        if (left <= 0) left = 0
        if (top <= 0) top = 0
        if (left >= maxLeft) left = maxLeft
        if (top >= maxTop) top = maxTop

        if (origin === 'top-right') {
          el.style.right = containerWidth - left - elmWidth + 'px'
          el.style.top = top + 'px'
        } else if (origin === 'bottom-left') {
          el.style.left = left + 'px'
          el.style.bottom = containerHeight - top - elmHeight + 'px'
        } else if (origin === 'bottom-right') {
          el.style.right = containerWidth - left - elmWidth + 'px'
          el.style.bottom = containerHeight - top - elmHeight + 'px'
        } else {
          el.style.left = left + 'px'
          el.style.top = top + 'px'
        }
      }

      function handleMouseUp(e) {
        document.removeEventListener('mousemove', handleMouseMove)
        document.removeEventListener('mouseup', handleMouseUp)
        overIframeDiv && el.parentNode.removeChild(overIframeDiv)

        const moveX = e.clientX - startClientX
        const moveY = e.clientY - startClientY
        // 只有移动距离超过5px，才判定为拖动
        const isMoved = Math.sqrt(moveX * moveX + moveY * moveY) > 5

        // 发生拖动后，阻止点击事件向子元素传递
        function stopChildrenClick(e) {
          e.stopPropagation()
          hanleElm.removeEventListener('click', stopChildrenClick, true)
        }
        if (!handle && isMoved) {
          hanleElm.addEventListener('click', stopChildrenClick, true)
        }
        setTimeout(() => {
          hanleElm.removeEventListener('click', stopChildrenClick, true)
        }, 100)

        // 发生拖动后，添加向左吸附的效果
        el.style.transition = 'all 0.3s ease-out'
        el.style.left = 10 + 'px'
      }

      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
    }

    hanleElm.addEventListener('mousedown', el.handleMousedown)
  },
  unbind(el, binding) {
    const { handle } = binding.value || {}
    const hanleElm = handle ? el.querySelector(handle) : el
    if (!hanleElm || !el.handleMousedown) return
    hanleElm.removeEventListener('mousedown', el.handleMousedown)
  },
}
